'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  border-radius: ', ';\n  display: inline-block;\n  font-weight: normal;\n  letter-spacing: 0.0375em;\n  line-height: 1.25;\n  text-transform: uppercase;\n'], ['\n  border-radius: ', ';\n  display: inline-block;\n  font-weight: normal;\n  letter-spacing: 0.0375em;\n  line-height: 1.25;\n  text-transform: uppercase;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Badge = (0, _styledComponents2.default)(_Text2.default.span)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.radius;
});

Badge.displayName = 'Badge';

Badge.defaultProps = {
  theme: _theme2.default,
  px: 2,
  py: 1,
  bg: 'primary',
  color: 'white',
  fontSize: 1
};

exports.default = Badge;